import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { NameAndEmailItem } from '../../core/models/name-and-email-item.model';

@Injectable({ providedIn: 'root' })
export class VendorService {
    constructor(private httpClient: HttpClient) {}

    add(data: NameAndEmailItem): Observable<string> {
        return this.httpClient.post<any>(environment.apiInboxUrl + 'vendors/', data);
    }
}
